import React from 'react';

import { useGetMaintenanceStatusQuery } from 'src/api';

export const useMaintenanceStatus = (currentPath: string) => {
  const { data, loading, refetch } = useGetMaintenanceStatusQuery();

  const isInitialLoadFinished = !loading && data;

  React.useEffect(() => {
    if (isInitialLoadFinished) {
      refetch();
    }
  }, [currentPath, refetch, isInitialLoadFinished]);

  return {
    loading,
    isMaintenanceEnabled: data?.getMaintenanceStatus.isMaintenanceEnabled || false,
  };
};
